var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex ai-center"},[_c('div',{staticClass:"x-header-link-container m-l-auto"},[_c('router-link',{staticClass:"text-semibold btn-secondary BUTTON",attrs:{"to":{ name: 'login'},"tag":"button","selenium":"dashboard-button"}},[_vm._v("\n      Login To Your Account\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }